<template>
    <div class="theoryDetail" v-loading="loading">
        <el-button class="comeBack" icon="iconfont pro-icon-fanhui" type="text" @click="goBack">返回</el-button>
        <audio @canplay="canplay" :setAudioName="setAudioName" ref="audio" :src="haveDuration" />
        <div>
            <el-button class="saveBtn" type="primary" v-if="isModify" :disabled="loading"
                @click="saveQuestion">保存</el-button>
            <el-button class="saveBtn" type="primary" v-else :disabled="loading" @click="amend">修改</el-button>
            <el-row style="margin-bottom:20px">
                <el-col :span="6">
                    <div class="theTit">
                        <p style="margin-right:20px"><span v-if="isModify" style="color:red;">*</span>归属科目:</p>
                        <el-select v-model="visibleObj.subjectId" filterable placeholder="请选择"
                            style="width:65%;text-align:left" v-if="isModify"
                            @change="changeSelect(1, visibleObj.subjectId)">
                            <el-option v-for="item in gsSubList" :key="item.subjectId
                                " :label="item.name" :value="item.subjectId"></el-option>
                        </el-select>
                        <p v-else>{{ row.subjectName }}</p>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="theTit">
                        <p style="margin-right:20px"><span v-if="isModify" style="color:red;">*</span>级别:</p>
                        <el-select v-model="visibleObj.subjectLevel" filterable placeholder="请选择"
                            style="width:65%;text-align:left" v-if="isModify"
                            @change="changeSelect(2, visibleObj.subjectLevel)">
                            <el-option v-for="item in levelList" :key="item.subjectLevel
                                " :label="item.name" :value="item.subjectLevel"></el-option>
                        </el-select>
                        <p v-else><span v-if="row.subjectLevel != ''">{{ levelList.filter(item => {
                            return item.subjectLevel == row.subjectLevel
                        })[0].name }}</span></p>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="theTit">
                        <p style="margin-right:20px"><span v-if="isModify" style="color:red;">*</span>归属部分:</p>
                        <el-select v-model="visibleObj.type" filterable placeholder="请选择" style="width:65%;text-align:left"
                            v-if="isModify" @change="changeSelect(3, visibleObj.type)">
                            <el-option v-for="item in typeSeleList" :key="item.questionsUuid" :label="item.name"
                                :value="item.questionsUuid"></el-option>
                        </el-select>
                        <p v-else><span v-if="row.questionsUuid != ''">{{ typeSeleList.filter(item => {
                            return item.questionsUuid == row.questionsUuid
                        })[0].name }}</span></p>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="theTit">
                        <p style="margin-right:20px"><span v-if="isModify" style="color:red;">*</span>
                            知识点类别:</p>
                        <el-select v-model="visibleObj.node" filterable placeholder="请选择" style="width:65%;text-align:left"
                            v-if="isModify">
                            <el-option v-for="item in knowsList" :key="item.name" :label="item.name"
                                :value="item.name"></el-option>
                        </el-select>
                        <p v-else><span v-if="row.node != ''">{{ row.node }}</span></p>
                    </div>
                </el-col>
            </el-row>
            <div class="testList">
                <div class="testItem" v-for="(test, index) in questionList" :key="index">
                    <img v-if="visiType == 1" @click="deleQuestion(index)" class="deleItem"
                        src="@/assets/img/deleteIcon.png" alt="">
                    <el-row class="elRow">
                        <el-col :span="2">
                            <p class="titles" style="line-height:40px">
                                <span v-if="isModify && visiType == 1" style="color:red;">*</span>题号:
                            </p>
                        </el-col>
                        <el-col :span="22">
                            <el-input v-if="isModify && visiType == 1" @input="expNumber(index)" style="width:10%"
                                maxlength="7" placeholder="请输入" v-model="test.questionsTh"></el-input>
                            <p style="line-height: 40px;" v-else>{{ test.questionsTh }}</p>
                        </el-col>
                    </el-row>
                    <el-row class="elRow">
                        <el-col :span="2">
                            <div>
                                <!-- <p class="titles">{{ test.questionsTh }}</p> -->
                                <p class="titles"><span v-if="isModify" style="color:red;">*</span>试题名称:</p>
                            </div>
                        </el-col>
                        <el-col :span="22">
                            <el-input v-if="isModify" style="width:100%" type="textarea" maxlength="500" :rows="5"
                                placeholder="请输入内容" v-model="test.name"></el-input>
                            <p v-else class="detailTestName">{{ test.name }}</p>
                        </el-col>
                    </el-row>
                    <el-row class="upFile" v-if="isModify || test.nameUrl.length != 0"
                        style="display: flex;align-items:center">
                        <el-col :span="2">
                            <div>
                                <p class="titles">试题文件:</p>
                            </div>
                        </el-col>
                        <el-col :span="22" style="display: flex;align-items:center">
                            <template v-if="isModify">
                                <el-upload style="display:inline-block;margin-right:10px;"
                                    :disabled="test.nameUrl.length > 1" ref="upload" class="upload-demo" :accept="accepts"
                                    :on-success="(res => { handleUploadSuccess(res, index) })" :before-upload="beforeUpload"
                                    :action="action" :show-file-list="false">
                                    <el-button :disabled="test.nameUrl.length > 1" type="primary">+上传文件</el-button>
                                </el-upload>
                                <template v-if="test.nameUrl.length > 0">
                                    <div class="titFile" v-for="(file, sum) in test.nameUrl" :key="sum + 'file'">
                                        <div class="autioDiv" v-if="$expForMat(file.fileName)">
                                            <autioCate :name="false" width="180px" height="30px" :audioSrc="file" />
                                            <img @click="deleAudioInfo(index, sum)" class="icons"
                                                src="@/assets/img/clean1.png" alt="">
                                        </div>
                                        <div class="autioDiv" v-else>
                                            <img :src="file.url" @click="toUploadImg">
                                            <img @click="deleAudioInfo(index, sum)" class="icons"
                                                src="@/assets/img/clean1.png" alt="">
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <template>
                                    <div v-for="(file, sum) in test.nameUrl" :key="sum + 'file'">
                                        <div class="titFile">
                                            <div class="autioDiv" v-if="$expForMat(file.fileName)">
                                                <autioCate :name="false" width="180px" height="30px" :audioSrc="file" />
                                            </div>
                                            <div class="autioDiv" v-else>
                                                <img :src="file.url">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row class="elRow">
                        <el-col :span="2">
                            <p class="titles" style="line-height:40px"><span v-if="isModify" style="color:red;">*</span>题型:
                            </p>
                            <p v-if="test.tx == 3" class="answerInfo">正确答案：<span v-for="(item, index) in test.answer"
                                    :key="index">{{ item }}</span></p>
                        </el-col>
                        <el-col :span="22">
                            <el-select @change="changeTixing(test.tx, index)" :disabled="test.tx == 4" v-model="test.tx"
                                filterable placeholder="请选择" style="width:15%;text-align:left" v-if="isModify">
                                <el-option v-for="item in tixingList" :key="item.value" :label="item.label"
                                    :value="item.value" :disabled="item.disabled"></el-option>
                            </el-select>
                            <p style="line-height: 40px;" v-else>
                                {{ tixingList.filter(item => {
                                    return item.value == test.tx
                                })[0].label }}
                            </p>
                        </el-col>
                    </el-row>
                    <el-row class="elRow" v-if="test.tx != 4">
                        <table>
                            <tbody>
                                <tr>
                                    <td class="listcss" colspan="15" style="text-align: left; font-weight: bold">
                                        | 试题选项
                                    </td>
                                </tr>
                                <tr>
                                    <td class="listcss">选项</td>
                                    <td class="listcss" colspan="9">选项内容</td>
                                    <td class="listcss" :colspan="isModify ? 3 : 4">附件</td>
                                    <td class="listcss">正确答案</td>
                                    <td class="listcss" v-if="isModify">操作</td>
                                </tr>
                                <tr v-for="(option, ind) in test.options" :key="ind">
                                    <td>{{ option.num }}</td>
                                    <template v-if="isModify">
                                        <td colspan="9"><el-input maxlength="300" v-model="option.content"
                                                placeholder="请输入内容"></el-input></td>
                                        <td colspan="3">
                                            <el-upload :ref="'upload' + index + option.num" :accept="accepts"
                                                :on-success="(res => { optionUploadSuccess(res, index, ind) })"
                                                :before-upload="(file => { return optionBeforeUpload(file, index, ind) })"
                                                :action="action" v-show="!option.fj.url" :show-file-list="false">
                                                <div class="upDiv">
                                                    <img src="@/assets/img/u60.svg" alt="">
                                                </div>
                                            </el-upload>
                                            <div class="upInfo" style="height:50px;border: none;" v-if="option.fj.url">
                                                <div class="autioDiv" style="height:100%"
                                                    v-if="$expForMat(option.fj.fileName)">
                                                    <autioCate :name="false" width="200px" height="50px"
                                                        :audioSrc="option.fj" />
                                                    <img @click="optionDeleAudioInfo(index, ind)" class="icons"
                                                        src="@/assets/img/clean1.png" alt="">
                                                </div>
                                                <img v-else :src="option.fj.url"
                                                    @click="optionToUpload('upload' + index + option.num)"
                                                    style="cursor: pointer;height: 100%;">
                                            </div>
                                        </td>
                                        <td> <el-radio v-if="test.tx == 1" style="margin-left:15px" v-model="test.answer"
                                                :label="option.num"><i></i></el-radio>
                                            <el-checkbox v-else style="margin-left:15px" v-model="test.answer"
                                                :label="option.num"><i></i></el-checkbox>
                                        </td>
                                        <td>
                                            <img v-if="ind == test.options.length - 1" class="operaIcon"
                                                src="@/assets/img/addRow.png" @click="addStxx(index, ind)" alt="">
                                            <img v-else class="operaIcon" @click="deleStxx(index, ind)"
                                                src="@/assets/img/deleteRow.png" alt="">
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td colspan="9">{{ option.content }}</td>
                                        <td colspan="4">
                                            <div class="upInfo" style="height:50px;border: none;" v-if="option.fj.url">
                                                <div class="autioDiv" style="height:100%"
                                                    v-if="$expForMat(option.fj.fileName)">
                                                    <autioCate :name="false" width="300px" height="50px"
                                                        :audioSrc="option.fj" />
                                                </div>
                                                <img v-else :src="option.fj.url" style="height: 100%;">
                                            </div>
                                        </td>
                                        <td v-if="test.answer">
                                            <img v-if="test.answer.split(',').findIndex(item => {
                                                return item == option.num
                                            }) != -1" src="@/assets/img/yes.svg" style="height: 50%;">
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </el-row>
                </div>
                <div class="addQuestion" @click="addQuestion" v-if="visiType == 1 && row.subjectName == ''">
                    + 添加试题
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import autioCate from '../../components/autioCate.vue'
export default {
    name: 'theoryDetail',
    components: { autioCate },
    data() {
        return {
            visibleObj: {
                subjectId: '',
                subjectLevel: '',
                type: '',
                node: ''
            },
            accepts: '.jpg,.png,.mp3,.wav',
            action: 'api/upload',
            info: {},
            visiType: 1,
            testList: [{}],
            // 上面筛选框
            gsSubList: [],
            levelList: [],
            typeSeleList: [],
            knowsList: [],
            tixingList: [{ label: '单选题', value: 1 }, { label: '多选题', value: 2 }, { label: '填空多选题', value: 3 }, { label: '音频题', disabled: true, value: 4 }],
            questionList: [{ tx: 1, answer: null, name: '', nameUrl: [], questionsTh: '', options: [{ content: '', fj: { url: "", time: 0, fileName: "" }, num: 'A' }, { content: '', fj: { url: "", time: 0, fileName: "" }, num: 'B' }] }],
            radio: 'A',
            letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
            loading: true,
            row: { subjectName: '', subjectLevel: '', questionsUuid: '', node: '' },
            testDetail: {},
            toAmend: false,
            haveDuration: "",
            setAudioName: "",
            maxNum: '',
        }
    },
    mounted() {
        this.visiType = this.$route.query.visiType
        this.getSelect()
        this.loading = true
    },
    computed: {
        isModify() {
            return (this.visiType == 1 && this.row.subjectName == '') || this.toAmend
        }
    },
    methods: {
        goBack() {
            this.$router.push({
                path: '/information/theoryQuestionBank',
            })
        },
        expNumber(num) {
            this.questionList[num].questionsTh = this.questionList[num].questionsTh.replace(/[^\d]/g, '')
        },
        getDetail() {
            this.$axios.get(`/basicQuestionsLibrary/selectOne/${this.row.id}`).then((res) => {
                this.testDetail = res.data.data
                if (!this.testDetail.nameUrl) {
                    this.testDetail.nameUrl = []
                }
                if (this.testDetail.options) {
                    this.testDetail.options.forEach(item => {
                        if (!item.fj) {
                            item.fj = { url: "", time: 0, fileName: "" }
                        }
                    })
                }
                this.questionList = [this.testDetail]
            });
        },
        optionDeleAudioInfo(index, ind) {
            this.questionList[index].options[ind].fj = { url: "", time: 0, fileName: "" }
        },
        optionBeforeUpload(file, index, ind) {
            const isJPG = this.$uploadForMat(file.name);
            const isLt30M = file.size / 1024 / 1024 < 30;
            if (!isJPG) {
                this.$message.error("上传文件只能是 png、jpg、jpeg、mp3格式!");
            }
            if (!isLt30M) {
                this.$message.error("上传文件大小不能超过30MB!");
            }
            if (isJPG && isLt30M) {
                this.questionList[index].options[ind].fj = { url: "", time: 0, fileName: "" }
                this.loading = true
            }
            return isJPG && isLt30M;
        },
        optionUploadSuccess(res, index, ind) {
            if (res.code == "10000") {
                this.$message({ type: "success", message: '上传成功!', duration: 1000 });
                this.questionList[index].options[ind].fj = res.data
                this.haveDuration = this.questionList[index].options[ind].fj.url
                this.setAudioName = `option,${index},${ind}`
            } else {
                this.$message({ type: "error", message: res.msg, duration: 1000 });
            }
            this.loading = false
        },
        deleAudioInfo(i, num) {
            this.questionList[i].nameUrl.splice(num, 1)
        },
        toUploadImg() {
            this.$refs['upload'][0].$refs['upload-inner'].handleClick()
        },
        optionToUpload(name) {
            this.$refs[name][0].$refs['upload-inner'].handleClick()
        },
        // 文件上传成功的处理函数
        handleUploadSuccess(res, num) {
            if (res.code == "10000") {
                this.$message({ type: "success", message: `上传成功!`, duration: 1000 });
                this.questionList[num].nameUrl.push(res.data)
                this.questionList[num].nameUrl.forEach((item, index) => {
                    if (this.$expForMat(item.url) && item.time == 0) {
                        this.haveDuration = item.url
                    }
                    this.setAudioName = `questionList,${num},${index}`
                })
            } else {
                this.$message({ type: "error", message: res.msg, duration: 1000 });
            }
            this.loading = false
        },
        canplay() {
            let arr = this.setAudioName.split(',')
            if (arr[0] == 'questionList') {
                this.questionList[arr[1]].nameUrl[arr[2]].time = this.$refs.audio.duration
            } else {
                this.questionList[arr[1]].options[arr[2]].fj.time = this.$refs.audio.duration
            }
        },
        // 限制上传文件
        beforeUpload(file) {
            const isJPG = this.$uploadForMat(file.name);
            const isLt30M = file.size / 1024 / 1024 < 30;
            if (!isJPG) {
                this.$message.error("上传文件只能是 png、jpg、jpeg、mp3格式!");
            }
            if (!isLt30M) {
                this.$message.error("上传文件大小不能超过30MB!");
            }
            if (isJPG && isLt30M) {
                this.loading = true
            }
            return isJPG && isLt30M;
        },
        changeSelect(num, val) {
            if (num == 1) {
                this.visibleObj.subjectLevel = ''
                this.visibleObj.type = ''
                this.visibleObj.node = ''
                this.typeSeleList = []
                this.knowsList = []
                this.levelList = this.gsSubList.filter(item => {
                    return item.subjectId == val
                })[0].chilren
            }
            else if (num == 2) {
                this.visibleObj.type = ''
                this.visibleObj.node = ''
                this.knowsList = []

                this.typeSeleList = this.levelList.filter(item => {
                    return item.subjectLevel == val
                })[0].chilren
            } else if (num == 3) {
                if (this.typeSeleList.filter(item => {
                    return this.visibleObj.type == item.questionsUuid
                })[0].type == 3) {
                    this.questionList = this.questionList.map(item => {
                        return { tx: 4, name: item.name, nameUrl: item.nameUrl }
                    })
                } else {
                    this.questionList = this.questionList.map(item => {
                        return { tx: 1, answer: null, name: item.name, questionsTh: item.questionsTh, nameUrl: item.nameUrl, options: [{ content: '', fj: { url: "", time: 0, fileName: "" }, num: 'A' }, { content: '', fj: { url: "", time: 0, fileName: "" }, num: 'B' }] }
                    })
                }
                this.visibleObj.node = ''

                this.knowsList = this.typeSeleList.filter(item => {
                    return item.questionsUuid == val
                })[0].nodes
            }
        },
        getSelect() {
            this.$axios.get("/basicQuestionsLibrary/cascade").then((res) => {
                this.gsSubList = res.data.data
                if (this.visiType == 2) {
                    this.row = JSON.parse(this.$route.query.row)
                    this.getDetail()
                    this.levelList = this.gsSubList.filter(item => {
                        return item.subjectId == this.row.subjectId
                    })[0].chilren
                    this.typeSeleList = this.levelList.filter(item => {
                        return item.subjectLevel == this.row.subjectLevel
                    })[0].chilren
                    this.knowsList = this.typeSeleList.filter(item => {
                        return item.questionsUuid == this.row.questionsUuid
                    })[0].nodes
                    this.row
                }
                this.loading = false
            });
        },
        amend() {
            this.visibleObj.subjectId = this.row.subjectId
            this.visibleObj.subjectLevel = String(this.row.subjectLevel)
            this.visibleObj.type = String(this.row.questionsUuid)
            this.visibleObj.node = this.row.node
            this.questionList.forEach((item) => {
                if (item.tx == 2 || item.tx == 3) {
                    item.answer = item.answer.split(',')
                }
            })
            this.toAmend = true
        },
        saveQuestion() {
            console.log(551, this.questionList);
            if (this.visibleObj.subjectId == '') {
                this.$message.error({ message: "归属科目未填写!", duration: 1000 });
                return
            }
            if (this.visibleObj.subjectLevel == '') {
                this.$message.error({ message: "级别未填写!", duration: 1000 });
                return
            }
            if (this.visibleObj.type == '') {
                this.$message.error({ message: "归属部分未填写!", duration: 1000 });
                return
            }
            if (this.visibleObj.node == '') {
                this.$message.error({ message: "知识点未填写!", duration: 1000 });
                return
            }
            let checkName = 0
            let checkAnswer = 0
            let checkOption = 0
            this.questionList.forEach(item => {
                if (item.name == '') {
                    checkName += 1
                }
                if (item.tx != 4) {
                    if (item.answer == '' || item.answer == [] || item.answer == null) {
                        checkAnswer += 1
                    }
                    item.options.forEach(item => {
                        if (item.content == '' && item.fj.fileName == '') {
                            checkOption += 1
                        }
                        console.log(99, item);
                    })
                }
            })
            if (checkName != 0) {
                this.$message.error({ message: "试题名称未填写!", duration: 1000 });
                return
            }
            if (checkAnswer != 0) {
                this.$message.error({ message: "正确答案未填写!", duration: 1000 });
                return
            }
            if (checkOption != 0) {
                this.$message.error({ message: "选项内容未填写!", duration: 1000 });
                return
            }
            if (this.visiType == 1) {
                let subInfo = this.questionList.map((item, index) => {
                    return { ...item, px: index + 1 }
                })
                subInfo.forEach(item => {
                    if (JSON.stringify(item.nameUrl) == '[]') {
                        item.nameUrl = null
                    }
                    if (item.tx != 4) {
                        item.options.forEach(item => {
                            if (JSON.stringify(item.fj) == '{}') {
                                item.fj = { url: "", time: 0, fileName: "" }
                            }
                        })
                    }
                })
                subInfo.forEach(item => {
                    if (Array.isArray(item.answer)) {
                        if (item.tx == '3') {
                            item.answer = item.answer.join(',')
                        } else {
                            item.answer = item.answer.sort().join(',')
                        }
                    }
                })
                this.$axios
                    .post("/basicQuestionsLibrary/save", {
                        data: subInfo,
                        node: this.visibleObj.node,
                        questionsUuid: this.visibleObj.type,
                    })
                    .then((res) => {
                        this.$message.success({ message: "保存成功!", duration: 1000 });
                        this.$router.push({ path: "/information/theoryQuestionBank" })
                    });
            }
            // 修改
            else {
                let subInfo = this.questionList.map((item, index) => {
                    return { ...item }
                })
                subInfo.forEach(item => {
                    if (Array.isArray(item.answer)) {
                        if (item.tx == '3') {
                            item.answer = item.answer.join(',')
                        } else {
                            item.answer = item.answer.sort().join(',')
                        }
                    }
                })
                this.$axios
                    .post("/basicQuestionsLibrary/update", {
                        ...subInfo[0],
                        node: this.visibleObj.node,
                        questionsUuid: this.visibleObj.type,
                    })
                    .then((res) => {
                        this.$message.success({ message: "保存成功!", duration: 1000 });
                        this.$router.push({ path: "/information/theoryQuestionBank" })
                    });
            }
        },
        changeTixing(tx, index) {
            if (tx == 1) {
                this.questionList[index].answer = ''
            } else {
                this.questionList[index].answer = []
            }
        },
        addStxx(num, i) {
            if (this.questionList[num].options.length > 7) {
                this.$message.warning('一道试题最多8个选项')
                return
            } else {
                this.questionList[num].options.push({ content: '', fj: { url: "", time: 0, fileName: "" }, num: this.letters[i + 1] })
            }
        },
        deleStxx(num, i) {
            if (this.questionList[num].options.length < 3) {
                this.$message.warning('一道试题最少2个选项')
                return
            } else {
                this.questionList[num].options.splice(i, 1)
                this.questionList[num].options = this.questionList[num].options.map((item, index) => {
                    item.num = this.letters[index]
                    return item
                })
            }
        },
        addQuestion() {
            if (this.visibleObj.type != '' && this.typeSeleList.filter(item => {
                return this.visibleObj.type == item.questionsUuid
            })[0].type == 3) {
                this.questionList.push({ tx: 4, name: '', nameUrl: [] })
            } else {
                this.questionList.push({ tx: 1, answer: null, name: '', nameUrl: [], questionsTh: '', options: [{ content: '', fj: {}, num: 'A' }, { content: '', fj: { url: "", time: 0, fileName: "" }, num: 'B' }] })
            }
        },
        deleQuestion(num) {
            this.$dailog({
                title: "测试",
                context: "是否删除该试题？",
                callbackFun: () => {
                    this.questionList.splice(num, 1)
                },
            });
        },
    },

}
</script>

<style lang="scss" scoped>
.comeBack {
    cursor: pointer;
    position: absolute;
    right: -120px;
    top: -55px;
    z-index: 999;
}

.detailTestName {
    min-height: 117px;
    display: block;
    resize: vertical;
    padding: 5px 15px;
    line-height: 1.5;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: #606266;
    background-color: #FFF;
    background-image: none;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}

.answerInfo {
    color: #1890ff;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
}

.autioDiv {
    display: flex;
    align-items: center;
}

.icons {
    width: 25px;
    margin-left: 10px;
    cursor: pointer;
}

.saveBtn {
    position: absolute;
    right: -120px;
    top: 0;
}

.theoryDetail {
    position: relative;
    margin: 0 auto 50px;
    width: 85%;
}

.addQuestion {
    margin-top: 30px;
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    border: 2px dashed #e4e4e4;
    color: #1890ff;
    font-size: 18px;
    cursor: pointer;
}

.upFile {
    margin-bottom: 20px;
}

// .upload-demo {
//     height: 115px;
//     // text-align: center;
//     position: relative;
//     border: 1px solid #dcdfe6;
//     border-left: none;
//     text-align: center;

//     .upDiv {
//         position: absolute;
//         top: 50%;
//         left: 50%;
//         transform: translate(-50%, -50%);

//         .upTxt {
//             color: #bdbdbd;
//         }
//     }

// }
.titFile {
    display: inline-block;
    height: 100%;
    max-width: 500px;
    margin-right: 10px;
    padding-left: 10px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    background: #f4f4f4;
    padding: 10px;
    border-left: none;
    text-align: center;

    img {
        height: 30px;
        object-fit: contain;
        max-width: 92%;
    }

    .autioDiv {
        height: 30px;
        max-width: 600px;
    }
}

.upInfo {
    height: 117px;
    padding-left: 10px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: none;
    text-align: center;

    img {
        height: 115px;
        object-fit: contain;
    }
}

.theTit {
    display: flex;
    line-height: 50px;
}

.testList {
    .testItem {
        border: 2px dashed #e4e4e4;
        padding: 30px 20px;
        position: relative;
        margin-bottom: 20px;

        .deleItem {
            width: 70px;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 99;
        }

        .titles {
            text-align: right;
            margin-right: 10px;
        }

        .elRow {
            position: relative;
            margin-bottom: 10px;
        }
    }
}

.operaIcon {
    width: 25px;
    cursor: pointer;
}

table {
    border-collapse: collapse;
    width: 100%;
    color: #444;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 400;
    margin-bottom: 20px;
    text-align: center;

    thead {
        height: 48px !important;
        border: 1px solid #e0e0e0;
    }

    tr {
        border: 1px solid #e0e0e0;
    }

    th,
    td {
        border: 1px solid #e0e0e0;
        height: 48px;
        padding-left: 10px;
        width: 180px;
    }

    .left_cont {
        text-align: left;
        padding-left: 10px;
        font-weight: bold;
    }

    .listcss {
        background: #f2f2f2;
        width: 180px;
    }
}
</style>